<div class="login-content">
  <div class="login-form-section">
    <div class="logo-section marginBottom10px">
      <acengage-logo [classesToAdd]="'authPage'"></acengage-logo>
    </div>
   <router-outlet></router-outlet>
  </div>
</div>
